import { IncomingMessage, MessageHandler } from '@carvana/merch-native';
import { useContext, useMemo } from 'react';
import RecentVehiclesContext from '~/context/home/RecentVehiclesContext';
import SuggestedForYouContext from '~/context/home/SuggestedForYouContext';
import { ListenerEvent, type ListenerEventType } from './constants';

type VdpViewedPayload = {};

function isVdpViewedMessage(
  message: IncomingMessage<ListenerEventType, any>
): message is IncomingMessage<ListenerEventType, VdpViewedPayload> {
  return message.event === ListenerEvent.VdpViewed;
}

export default function useVdpViewedHandler(): MessageHandler<
  ListenerEventType,
  VdpViewedPayload
> {
  const { triggerFetchRecentVehicles } = useContext(RecentVehiclesContext);
  const { triggerFetchSuggestedForYou } = useContext(SuggestedForYouContext);

  return useMemo(
    () =>
      new MessageHandler(isVdpViewedMessage, () => {
        triggerFetchRecentVehicles();
        triggerFetchSuggestedForYou();
      }),
    [triggerFetchRecentVehicles, triggerFetchSuggestedForYou]
  );
}
